export default class Cookies {
  static getCookie(name) {
    var name = name + '='
    var cookies = document.cookie.split(';')

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i]

      while (cookie.charAt(0)==' ') {
        cookie = cookie.substring(1)
      }
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length)
      }
    }
    return ''
  }

  static setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)) // Convert days to milliseconds
    var expires = 'expires=' + date.toUTCString()
    document.cookie = name + '=' + value + '; ' + expires
  }
}
